import { render, staticRenderFns } from "./vFormQR_CODE.vue?vue&type=template&id=2016c718&scoped=true&"
import script from "./vFormQR_CODE.vue?vue&type=script&lang=js&"
export * from "./vFormQR_CODE.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2016c718",
  null
  
)

export default component.exports